import axios from 'axios';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

// Define the type for the clusters response
export interface ClustersResponse {
  clusters: string[];
  count: number;
}

// Set the API base URL - use the proxy to avoid CORS issues
const CLUSTER_API_URL = 'https://api.status.gridbit.live/api/v1/clusters';

// Define the state interface
interface ClustersState {
  clusters: string[];
  count: number;
  loading: boolean;
  error: string | null;
}

const initialState: ClustersState = {
  clusters: [],
  count: 0,
  loading: false,
  error: null,
};

// Create async thunk for fetching clusters
export const fetchClusters = createAsyncThunk(
  'clusters/fetchClusters',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(CLUSTER_API_URL);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching clusters:', error);
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch clusters');
    }
  }
);

// Create the clusters slice
export const clustersSlice = createSlice({
  name: 'clusters',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClusters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClusters.fulfilled, (state, action: PayloadAction<ClustersResponse>) => {
        state.loading = false;
        state.clusters = action.payload.clusters;
        state.count = action.payload.count;
      })
      .addCase(fetchClusters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default clustersSlice.reducer; 